/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_Extended_Access_IncludedInputs */

const fr_plan_choice_extended_access_included = /** @type {(inputs: Plan_Choice_Extended_Access_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès 6h-23h inclus`)
};

/**

* @param {Plan_Choice_Extended_Access_IncludedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_extended_access_included = /** @type {((inputs?: Plan_Choice_Extended_Access_IncludedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Extended_Access_IncludedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_extended_access_included(inputs)
});